export const questionsOne = [
  {
    id: 1,
    question: "Find the odd one out.",
    answer: "Rubber",
    options: ["chalk", "Duster", "Blackboard", "Rubber"],
    explanations: [
      "Chalk, Duster, and Blackboard are related to each other, whereas Rubber can only be used to erase on the paper.",
    ],
  },
  {
    id: 2,
    question:
      "In a certain code MONARCHY is written as NPOBSDIZ. How will STANDARD be written in the code? ",
    answer: "TUBOEBSE",
    options: ["UTBODCSE", "TUCOEDSE", "TUBOFBSE", "TUBOEBSE"],
    explanations: [
      "Each letter of 'MONARCHY' is simply replaced by its next letter as per the English alphabet.",
    ],
  },
  {
    id: 3,
    question: "What does the following proverb means - `Once in a blue moon.",
    answer: "Something that happens very infrequently",
    options: [
      "Something that is very common",
      "New moon day",
      "Something that happens very infrequently",
      "Large object which is blue in colour",
    ],
    explanations: [
      "Once in a blue moon - Something that happens very infrequently",
    ],
  },
  {
    id: 4,
    question:
      "India has its majority of the population depended on Industrial Production.",
    answer: "False",
    options: ["True", "False", "Absurd", "None of these"],
    explanations: ["Indian minority population depends on agriculture."],
  },
  {
    id: 5,
    question:
      "From the four options, one can replace the capitalized word without changing the meaning of the sentence. The Doctor ASSISTED the patient to recover from his illness.",
    answer: "Helped",
    options: ["Restricted", "Distracted", "Distracted ", "Helped"],
    explanations: ["Help is the synonym of Assist."],
  },
  {
    id: 6,
    question: "Find the correct word from the given jumble word. TRIUF",
    answer: "FRUIT",
    options: ["TRIFU", "FUTIR", "FRUIT", "FITRU"],
    explanations: ["TRIUF can be unjumbeld to FRUIT."],
  },
  {
    id: 7,
    question: "Doctor : Nurse :: ? : Follower",
    answer: "Leader",
    options: ["Employer", "Leader", "Worker", "Union"],
    explanations: [
      "Just as a nurse follows the doctor's instructions, so also a follower works as directed by the leader.",
    ],
  },
  {
    id: 8,
    question: "Moon : Satellite :: Earth : ?",
    answer: "Planet",
    options: ["Sun", "Solar system", "Asteroid", "Planet"],
    explanations: ["Moon is a satellite and Earth is a planet."],
  },
  {
    id: 9,
    question: "Clock : Time :: Thermometer : ?",
    answer: "Temperature",
    options: ["Heat", "Radiation", "Energy", "Temperature"],
    explanations: [
      "Clock is a device to see or measure time. Similarly, the temperature is measured by the thermometer.",
    ],
  },
  {
    id: 10,
    question: "Acting : Theater :: ? : Casino",
    answer: "Gambling",
    options: ["Gambling", "Dance", "Workout", "Eating"],
    explanations: [
      "Theatre is the place where acting is performed. A casino is a building for gambling and entertainment.",
    ],
  },
  {
    id: 11,
    question:
      "Museum is related to curator in the same way as prison is related to...",
    answer: "Jailor",
    options: ["Manager", "Monitor", "Jailor", "Warden"],
    explanations: [
      "Person in charge of a 'Museum' is known as 'Curator' Likewise person in charge of a 'Prison' is called 'Jailor'.",
    ],
  },
  {
    id: 12,
    question: "1, 3, 5, 7, _",
    answer: "9",
    options: ["8", "9", "10", "11"],
    explanations: [
      "This is an arithmetic sequence since there is a common difference between each term. In this case, adding 2 to the previous term in the sequence gives the next term.",
    ],
  },
  {
    id: 13,
    question: "25 : 125 :: 36: ?",
    answer: "216",
    options: ["180", "206", "216", "318"],
    explanations: ["The relationship is X^2:X^3."],
  },
  {
    id: 14,
    question: "17 : 52 :: 1 : ?",
    answer: "4",
    options: ["3", "4", "5", "51"],
    explanations: ["The relationship is x : (3x + 1)."],
  },
  {
    id: 15,
    question: "12 : 144",
    answer: "20 : 400",
    options: ["22 : 464", "15 : 135", "10 : 140", "20 : 400"],
    explanations: [
      "The relation that exists here is second no. is square of the first number.",
    ],
  },
  {
    id: 16,
    question:
      "Bread is related to bakery in the same way as Brick is realated to...",
    answer: "Kiln",
    options: ["Mint", "Kiln", "Furnace", "Mine"],
    explanations: ["Second is the place where the first is manufactured."],
  },
  {
    id: 17,
    question:
      "Drama is related to scene in the same way as Book is related to ",
    answer: "Chapter",
    options: ["Story", "Page", "Chapter", "Author"],
    explanations: [
      "Drama is related to the scene in the same way as the book is related to the chapter.",
    ],
  },
  {
    id: 18,
    question:
      "Author is related to Book in the same way as Choreographer is related to...",
    answer: "Ballet",
    options: ["Drama", "Ballet", "Masque", "Opera"],
    explanations: ["First composes the second."],
  },
  {
    id: 19,
    question: "Chalk : Blackboard",
    answer: "Ink : Paper",
    options: ["Type : paint", "Table : Chair", "Ink : Paper", "Door : Handle"],
    explanations: [
      "As Chalk is used to write on the blackboard, Ink is used to write on the Paper.",
    ],
  },
  {
    id: 20,
    question: "Train : Track",
    answer: "Bullet : Barrel",
    options: [
      "Idea : Brain",
      "Bullet : Barrel",
      "Water : Boat",
      "Fame : Television",
    ],
    explanations: [
      "A train moves on tracks. Similarly, a bullet travels through the barrel of the gun.",
    ],
  },
  {
    id: 21,
    question:
      "In a certain word, SIKKIM is written as THLJJL. How is TRAINING written in the code?",
    answer: "UQBHOHOF",
    options: ["SQBHOHOH", "UQBHOHOF", "UQBJOHHO", "None of these"],
    explanations: [
      "Clearly, the letters in the word SIKKIM are moved alternately one step forward and one step backward to obtain the letters of the code. (S → T), (I ← H), (K → L), (K ← J), (I → J), (M ← L)",
    ],
  },
  {
    id: 22,
    question:
      "In certain code, FORGE is written as FPTJI. How is CULPRIT written in that code?",
    answer: "CVNSVNZ",
    options: ["CSJNPGR", "CVMQSTU", "CVNSVNZ", "CXOSULW"],
    explanations: [
      "Here, the first letter of the word 'FORGE' remains the same whereas other letters move one, two, three, and four steps forward to obtain the corresponding letters of the code FPTJI. Similarly, CULPRIT is written as CVNSVNZ.",
    ],
  },
  {
    id: 23,
    question:
      "A man said to a lady, `Your mother's husband's sister is my aunt`. How is the lady related to the man?",
    answer: "Sister",
    options: ["Aunt", "Sister", "Mother", "Daughter"],
    explanations: [
      "Your mother's husband is your father; your father's sister is your aunt. So, lady's aunt is man's aunt and therefore lady is man's sister.",
    ],
  },
  {
    id: 24,
    question:
      "X introduces Y saying, `He is the husband of the granddaughter of the father of my father.` How is Y related to X?",
    answer: "Brother-in-law",
    options: ["Brother", "Son", "Brother-in-law", "Nephew"],
    explanations: [
      "The relations may be analyzed as follows: Father's father ⇒ Grandfather; Grandfather's Granddaughter ⇒ Sister; Sister's husband ⇒  Brother-in-law. So, Y is X's brother-in-law.",
    ],
  },
  {
    id: 25,
    question:
      "In a certain code TRIPPLE is written as SQHOOKD. How is DISPOSE Written in that code?",
    answer: "CHRONRD",
    options: ["CHRONRD", "DSOESPI", "ESJTPTF", "ESOPSID"],
    explanations: [
      "Each letter in the word is moved one step backward to obtain the corresponding letter of the code.",
    ],
  },

  {
    id: 26,
    question:
      "If DELHI is coded as 73541 and CALCUTTA as 82589662, how can CALICUT be coded?",
    answer: "8251896",
    options: ["5279431", "5978213", "8251896", "8543691"],
    explanations: [
      "Since, in CALICUT, C is coded as 8, A is coded as 2, L as 5, I as 1, U as 9, T as 6. So, code for CALICUT IS 8251896.",
    ],
  },
  {
    id: 27,
    question:
      "Direction (Questions 27 to 31): If in certain language, ENTRY is coded as 12345 and STEADY is coded as 931785, then state which is the correct code for each of the given words. -TENANT",
    answer: "312723",
    options: ["956169", "196247", "352123", "312723"],
    explanations: [
      "E-1, N-2,	T-3,	R-4,	Y-5,	S-9,	A-7,	D-8. So, TENANT is coded as 312723.",
    ],
  },
  {
    id: 28,
    question:
      "Direction (Questions 27 to 31): If in certain language, ENTRY is coded as 12345 and STEADY is coded as 931785, then state which is the correct code for each of the given words. -NEATNESS",
    answer: "21732199",
    options: ["25196577", "21732199", "21362199", "21823698"],
    explanations: [
      "E-1, N-2,	T-3,	R-4,	Y-5,	S-9,	A-7,	D-8. So, So, NEATNESS is coded as 21732199.",
    ],
  },

  {
    id: 29,
    question:
      "Direction (Questions 27 to 31): If in certain language, ENTRY is coded as 12345 and STEADY is coded as 931785, then state which is the correct code for each of the given words. -SEDATE",
    answer: "918731",
    options: ["918731", "954185", "814195", "614781"],
    explanations: [
      "E-1, N-2,	T-3,	R-4,	Y-5,	S-9,	A-7,	D-8. So, So, SEDATE is coded as 918731.",
    ],
  },
  {
    id: 30,
    question:
      "Direction (Questions 27 to 31): If in certain language, ENTRY is coded as 12345 and STEADY is coded as 931785, then state which is the correct code for each of the given words. -ARREST",
    answer: "744193",
    options: ["744589", "744193", "166479", "745194"],
    explanations: [
      "E-1, N-2,	T-3,	R-4,	Y-5,	S-9,	A-7,	D-8. So, So, ARREST is coded as 744193.",
    ],
  },
  {
    id: 31,
    question:
      "Direction (Questions 27 to 31): If in certain language, ENTRY is coded as 12345 and STEADY is coded as 931785, then state which is the correct code for each of the given words. -ENDEAR",
    answer: "128174",
    options: ["524519", "174189", "128174", "124179"],
    explanations: [
      "E-1, N-2,	T-3,	R-4,	Y-5,	S-9,	A-7,	D-8. So, So, ENDEAR is coded as 128174.",
    ],
  },
  {
    id: 32,
    question:
      "A state of disorder due to absence or non-recognition of authority or other controlling systems is...",
    answer: "Anarchy",
    options: ["Autonomy", "Bureaucracy", "Autocracy", "Anarchy"],
    explanations: [
      "Autonomy - The right or condition of self-government.",
      "Bureaucracy - A system of government in which most of the important decisions are taken by state officials rather than by elected representatives.",
      "Autocracy - A system of government by one person with absolute power.",
      "Anarchy - A state of disorder due to absence or non-recognition of authority or other controlling systems.",
    ],
  },
  {
    id: 33,
    question:
      "A system of government by the whole population or all the eligible members of a state, typically through elected representatives is...",
    answer: "Democracy",
    options: ["Gerontocracy", "	Neocracy", "Democracy", "Oligarchy"],
    explanations: [
      "Gerontocracy - A state, society, or group governed by old people.",
      "Neocracy - Government by the new or inexperienced.",
      "Democracy - A system of government by the whole population or all the eligible members of a state, typically through elected representatives.",
      "Oligarchy - A small group of people having control of a country or organization.",
    ],
  },
  {
    id: 34,
    question: "A large burial ground, especially one not in a churchyard is...",
    answer: "Cemetery",
    options: ["Asylum", "Cemetery", "Crematorium", "Dormitory"],
    explanations: [
      "Asylum - An institution for the care of people who are mentally ill.",
      "Cemetery - A large burial ground, especially one not in a churchyard",
      "Crematorium - A place where a dead person's body is cremated.",
      "Dormitory - A large bedroom for several people in a school or institution.",
    ],
  },
  {
    id: 35,
    question: "A place where coins, medals, or tokens are made is...",
    answer: "Mint",
    options: ["Kennel", "Lair", "Monastery", "Mint"],
    explanations: [
      "Kennel - A small shelter for a dog.",
      "Lair - A place where a wild animal, especially a fierce or dangerous one, lives.",
      "Monastery - A building or buildings occupied by a community of monks living under religious vows.",
      "Mint - A place where coins, medals, or tokens are made.",
    ],
  },
  {
    id: 36,
    question: "Unjumble this word - 'NESBIGNRE'",
    answer: "BEGINNER",
    options: ["BEGINNER", "NERIGNBE", "BEGINEER", "BIGENEER"],
    explanations: ["NESBIGNRE - BEGINNER."],
  },
  {
    id: 37,
    question: "Unscramble the word - 'DECOUNTAI'",
    answer: "EDUCATION",
    options: ["DUCATEDUOI", "EDUCATION", "NIOTACUED", "ATIONEDU"],
    explanations: ["DECOUNTAI - EDUCATION."],
  },
  {
    id: 38,
    question:
      "Arrange the jumbled words to make meaningful sentences. Flying / birds / the / sky / in / are",
    answer: "The birds are flying in the sky",
    options: [
      "Birds are the flying in the sky",
      "The birds are flying in the sky",
      "In the sky flying are the birds",
      "Flying in the sky are the birds",
    ],
    explanations: [
      "Flying / birds / the / sky / in / are - The birds are flying in the sky.",
    ],
  },
  {
    id: 39,
    question:
      "Kiran is taller than Sameer but shorter than Pramod. John is taller than Urmila. Sameer is taller than John. Who is the tallest in the group?",
    answer: "Pramod",
    options: ["Kiran", "Sameer", "Pramod", "John"],
    explanations: ["Pramod > Kiran > Sameer > John > Urmila."],
  },
  {
    id: 40,
    question:
      "Prakash is taller than Geeta. Amar is taller than Prabhat but not as tall as Geeta. Prabodh is taller than Prakash. Who among them is the shortest?",
    answer: "Prabhat",
    options: ["Prakash", "Geeta", "Amar", "Prabhat"],
    explanations: ["Prabodh > Prakash > Geeta > Amar > Prabhat."],
  },
];
